import { DocumentInfo } from 'api';
import { TextField } from 'form';
import { useTranslation } from 'i18n';
import { Grid, Typography } from 'ui';

import { AddDocumentInMemoryButton, DocumentList } from '../../../document';

type Props = {
  externalReferenceNumberLabel: string;
  uploadedDocuments: DocumentInfo[];
};

export const SellerAdditionalDetailsAndDocumentsSection = ({
  externalReferenceNumberLabel,
  uploadedDocuments,
}: Props) => {
  const { t } = useTranslation('orders');

  return (
    <>
      <Typography variant="h6" fontWeight="bold">
        {t('sellerAdditionalDetailsAndDocumentsSection.title')}
      </Typography>
      <Grid container spacing={2}>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <TextField
            name="external_reference_number"
            label={externalReferenceNumberLabel}
            type="text"
            fullWidth
            infoTooltip={t('sellerAdditionalDetailsAndDocumentsSection.tooltips.externalReferenceNumber')}
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <TextField
            name="comments"
            label={t('sellerAdditionalDetailsAndDocumentsSection.labels.commentsOnPurchaseOrder')}
            type="text"
            fullWidth
            minRows={2}
            multiline
            infoTooltip={t('sellerAdditionalDetailsAndDocumentsSection.tooltips.commentsOnPurchaseOrder')}
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <TextField
            name="internal_notes"
            label={t('sellerAdditionalDetailsAndDocumentsSection.labels.internalNotes')}
            type="text"
            fullWidth
            minRows={2}
            multiline
            infoTooltip={t('sellerAdditionalDetailsAndDocumentsSection.tooltips.internalNotes')}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <AddDocumentInMemoryButton name="documents" />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <DocumentList name="documents" uploadedDocuments={uploadedDocuments} />
        </Grid>
      </Grid>
    </>
  );
};
